module.exports = __webpack_public_path__ + "static/media/job_blinds.6730f5dc.svg";